import { IUser } from '@boma/administration-portal/shared/entities';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as UsersActions from './users.actions';

export const USERS_FEATURE_KEY = 'users';

export interface UserState extends EntityState<IUser> {
  selectedId?: string | number; // which Users record has been selected
  loaded: boolean; // has the Users list been loaded
  error?: string | null; // last known error (if any)
}

export interface UsersPartialState {
  readonly [USERS_FEATURE_KEY]: UserState;
}

export const usersAdapter: EntityAdapter<IUser> = createEntityAdapter<IUser>();

export const initialUserState: UserState = usersAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const usersReducer = createReducer(
  initialUserState,
  on(UsersActions.loadUsers, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(UsersActions.loadUsersSuccess, (state, { payload }) =>
    usersAdapter.setAll(payload.items, { ...state, loaded: true })
  ),
  on(UsersActions.loadUsersFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(UsersActions.searchUsers, (state, { query }) => ({
    ...state,
    loaded: false,
    query,
  })),
  on(UsersActions.searchUsersSuccess, (state, { payload }) => {
    return usersAdapter.setAll(payload.items, {
      ...state,
      loaded: true,
      error: '',
    });
  }),

  on(UsersActions.setSelectedUser, (state, action) => {
    return {
      ...state,
      selectedId: action.userId,
    };
  }),
  on(UsersActions.loadUserDetailsSuccess, (state, { user }) =>
    usersAdapter.upsertOne(user, {
      ...state,
      loaded: true,
      error: '',
      selectedId: user.id,
    })
  ),
  on(UsersActions.loadUserDetailsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(UsersActions.addRoleUserSuccess, (state, { user }) =>
    usersAdapter.upsertOne(user, {
      ...state,
      loaded: true,
      error: '',
      selectedId: user.id,
    })
  ),
  on(UsersActions.addRoleUserFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(UsersActions.removeRoleUserSuccess, (state, { user }) =>
    usersAdapter.upsertOne(user, {
      ...state,
      loaded: true,
      error: '',
      selectedId: user.id,
    })
  ),
  on(UsersActions.removeRoleUserFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);

export function UsersReducer(state: UserState | undefined, action: Action) {
  return usersReducer(state, action);
}
